<div class="accordion" [ngClass]="{ 'box-shadow': !show }">
  <ion-item tappable lines="none" detail="false" [class]="class" (click)="arrow && statusHasChange()">
    <ion-label>
      <h2 no-margin>
        {{ tittle }}
      </h2>

      <h4 no-margin *ngIf="subtitle">
        <ion-icon
          [color]="pendencies === 0 ? 'success' : 'danger'"
          [name]="pendencies === 0 ? 'ios-checkmark-circle-outline' : 'md-alert'"
        ></ion-icon>
        {{ subtitle }}
      </h4>
    </ion-label>
    <ion-toggle
      *ngIf="toggle"
      slot="end"
      [checked]="show"
      mode="ios"
      (ionChange)="statusHasChange()"
    ></ion-toggle>
    <ion-icon
      *ngIf="arrow"
      slot="end"
      color="primary"
      [name]="show ? 'arrow-down' : 'arrow-forward'"
    ></ion-icon>
    <!-- Exibe apenas para tela de intervenientes -->
    <ion-icon
      *ngIf="canDeleteIntervener"
      color="primary"
      slot="end"
      src="assets/svg/trash.svg"
      (click)="openModal($event); $event.stopPropagation()"
    ></ion-icon>
  </ion-item>

  <div class="divider-bold" *ngIf="show"></div>
  <ion-list class="accordion ion-no-padding" *ngIf="show">
    <ng-content></ng-content>
  </ion-list>
</div>
